import { atom } from "jotai";

export const stepAtom = atom<number>(0);
